import { render } from "./OtiActions.vue?vue&type=template&id=88776e42&scoped=true"
import script from "./OtiActions.vue?vue&type=script&lang=js"
export * from "./OtiActions.vue?vue&type=script&lang=js"

import "./OtiActions.vue?vue&type=style&index=0&id=88776e42&lang=scss&scoped=true"

import exportComponent from "D:\\OSOLE\\metalpro\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88776e42"]])

export default __exports__